import { StandardEvents } from '@shopify/events';

/**
 * Haelt die Zoonova-Verfuegbarkeitsanzeige (.zoo-stock) beim Variantenwechsel aktuell.
 *
 * Ausgangslage: Die Anzeige steckt als Custom-Liquid-Block in der Produktvorlage. Ihr
 * Liquid ist korrekt - es fragt selected_or_first_available_variant ab - aber ein
 * Custom-Liquid-Block bringt keine eigene Aktualisierungslogik mit. Er blieb deshalb
 * auf dem Stand vom Seitenaufruf stehen: Wer die Variante wechselte, sah weiterhin den
 * Status der zuerst geladenen Variante. Der Warenkorb-Button war immer richtig, nur
 * diese Zeile nicht.
 *
 * Beim Variantenwechsel laedt das Theme die Produktseite ohnehin neu und reicht das
 * fertige HTML ueber das productSelect-Event durch. Darin steht die Anzeige bereits mit
 * dem richtigen Status - wir uebernehmen sie also nur in die Seite. Gleiches Vorgehen
 * wie assets/product-inventory.js beim Lagerbestands-Block.
 *
 * Bewusst ohne eigenes Markup und ohne eigene Texte: Quelle bleibt allein die
 * Produktvorlage, damit Aussehen, Klassen und Wortlaut unveraendert bleiben.
 *
 * Ausgetauscht wird das komplette Element, nicht nur sein Inhalt. Der Zustand steckt in
 * der Klasse am Wurzelelement (zoo-stock--in / zoo-stock--out), und die faerbt Punkt
 * und Text. Ein reines Ersetzen der Kindknoten wuerde den Text umstellen, die Farbe
 * aber auf dem alten Stand lassen.
 */

const STOCK_SELECTOR = '.zoo-stock';

/**
 * Uebernimmt den Verfuegbarkeitsstatus aus dem nachgeladenen HTML.
 * @param {Event & { promise?: Promise<any> }} event - Das productSelect-Event.
 */
const handleProductSelect = (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  // Variantenauswahl in Produktkarten oder Schnellansicht betrifft diese Anzeige nicht.
  if (target.closest('product-card')) return;
  if (!event.promise) return;

  // Nur den Bereich aktualisieren, in dem tatsaechlich umgeschaltet wurde.
  const scope = target.closest('.shopify-section, dialog') ?? document;
  if (!scope.querySelector(STOCK_SELECTOR)) return;

  event.promise
    .then((result) => {
      const html = result?.detail?.html;
      if (!html) return;

      const incoming = html.querySelector(STOCK_SELECTOR);
      // Frisch suchen: Der Bereich kann zwischenzeitlich neu gerendert worden sein.
      const current = scope.querySelector(STOCK_SELECTOR);
      if (!incoming || !current) return;

      current.replaceWith(incoming.cloneNode(true));
    })
    .catch((error) => {
      if (error?.name !== 'AbortError') {
        console.warn('[zoonova-stock-status] Aktualisierung fehlgeschlagen:', error);
      }
    });
};

document.addEventListener(StandardEvents.productSelect, handleProductSelect);
